let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gsmU3")).then(() => parcelRequire('c6YuO'));